import { render, staticRenderFns } from "./GiftCardForm.vue?vue&type=template&id=89a91e7c"
import script from "./GiftCardForm.vue?vue&type=script&lang=js"
export * from "./GiftCardForm.vue?vue&type=script&lang=js"
import style0 from "./GiftCardForm.vue?vue&type=style&index=0&id=89a91e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports